import React from "react";
import {
  Box,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { mediaSrc } from "../../utils/mediaSrc";

export default function ProductAdsInfluencerDialog({
  open,
  onClose,
  lang,
  influencers,
  loading,
  selectedId,
  onPick,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : 3,
          maxHeight: fullScreen ? "100%" : "min(88vh, 720px)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Typography variant="h6" fontWeight={800}>
          {lang?.productAdsPickCreator || "Choose creator"}
        </Typography>
        <IconButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Stack alignItems="center" py={4}>
            <CircularProgress />
          </Stack>
        ) : influencers.length === 0 ? (
          <Typography color="text.secondary" py={2}>
            {lang?.productAdsNoInfluencers ||
              "Create an active influencer with a photo under Influencers first."}
          </Typography>
        ) : (
          <Grid container spacing={1.5} sx={{ pt: 1 }}>
            {influencers.map((inf) => {
              const selected = Number(selectedId) === Number(inf.id);
              return (
                <Grid item xs={4} sm={3} key={inf.id}>
                  <Card
                    variant="outlined"
                    onClick={() => {
                      onPick(inf.id);
                      onClose();
                    }}
                    sx={{
                      cursor: "pointer",
                      borderWidth: selected ? 2 : 1,
                      borderColor: selected ? "primary.main" : "divider",
                      bgcolor: selected
                        ? alpha(theme.palette.primary.main, 0.08)
                        : "background.paper",
                    }}
                  >
                    <Box
                      component="img"
                      src={mediaSrc(inf.photo_url)}
                      alt={inf.name}
                      sx={{ width: "100%", aspectRatio: "1", objectFit: "cover" }}
                    />
                    <Typography variant="caption" sx={{ p: 0.75, display: "block" }} noWrap>
                      {inf.name}
                    </Typography>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
}
